import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Link } from 'react-router-dom';
import SafeIcon from '../../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiX, FiCheck, FiZap } = FiIcons;

const PaywallModal = ({ isOpen, onClose }) => {
  return (
    <AnimatePresence>
      {isOpen && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/80 backdrop-blur-sm"
          onClick={onClose}
        >
          <motion.div
            initial={{ scale: 0.9, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            exit={{ scale: 0.9, opacity: 0 }}
            className="bg-dark border border-primary/20 rounded-2xl p-8 max-w-md w-full relative"
            onClick={(e) => e.stopPropagation()}
          >
            <button
              onClick={onClose}
              className="absolute top-4 right-4 text-light/60 hover:text-light"
            >
              <SafeIcon icon={FiX} className="w-6 h-6" />
            </button>

            <div className="text-center">
              <div className="w-16 h-16 bg-gradient-to-r from-primary to-secondary rounded-full flex items-center justify-center mx-auto mb-6">
                <SafeIcon icon={FiZap} className="w-8 h-8 text-white" />
              </div>

              <h3 className="text-2xl font-bold mb-4">Unlock Unlimited Generations</h3>
              <p className="text-light/60 mb-6">
                You've reached your daily limit. Upgrade to Pro for unlimited generations, 
                A/B testing, and export features.
              </p>

              <div className="space-y-3 mb-6 text-left">
                <div className="flex items-center space-x-3">
                  <SafeIcon icon={FiCheck} className="w-5 h-5 text-primary" />
                  <span className="text-sm">Unlimited email generations</span>
                </div>
                <div className="flex items-center space-x-3">
                  <SafeIcon icon={FiCheck} className="w-5 h-5 text-primary" />
                  <span className="text-sm">Advanced A/B testing</span>
                </div>
                <div className="flex items-center space-x-3">
                  <SafeIcon icon={FiCheck} className="w-5 h-5 text-primary" />
                  <span className="text-sm">PDF & CSV export</span>
                </div>
                <div className="flex items-center space-x-3">
                  <SafeIcon icon={FiCheck} className="w-5 h-5 text-primary" />
                  <span className="text-sm">Project management</span>
                </div>
              </div>

              <div className="space-y-3">
                <Link
                  to="/pricing"
                  className="block w-full btn-primary py-3 rounded-lg text-white font-medium text-center"
                  onClick={onClose}
                >
                  Upgrade to Pro - $12/mo
                </Link>
                <button
                  onClick={onClose}
                  className="block w-full text-light/60 hover:text-light text-sm"
                >
                  Continue with Free Plan
                </button>
              </div>
            </div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default PaywallModal;